import React from "react"
import SectionHeader from "../../molecules/SectionHeader"
import Title from "../../atoms/Title"
import "./styles.scss"

const Perks = ({ perks, title, subtitle }) => {
  return (
    <section className="section section--perks">
      <div className="wrapper--text">
        <SectionHeader
          attributes={{
            "data-sal": "slide-up",
            "data-sal-duration": "1000",
            "data-sal-easing": "ease",
          }}
          type="h2"
          subtitle={subtitle}
        >
          {title}
        </SectionHeader>
        <div className="perks">
          {perks.map((perk, index) => {
            return (
              <div key={index} className="perk">
                <img className="perkImage" src={perk.icon.publicURL} alt={perk.heading} />
                <Title type="h4" className="perkTitle">
                  {perk.heading}
                </Title>
                <p className="perkDescription">{perk.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Perks
